import React, { useState, useEffect } from 'react';
import cn from 'classnames';

import fetchRequest from '../../../../utils/fetchRequest';
import DotsIcon from '../../../../assets/icons/common/DotsIcon';
import useNoty from '../../../../hooks/useNoty';
import paymentIcons from './paymentIcons';

import styles from './styles.module.scss';

const PaymentItem = ({
  paymentDetails,
  showUpdate = true,
  className,
  ...props
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const noty = useNoty();
  const cardExpMonth = paymentDetails?.payment_details?.exp_month
    ? String(paymentDetails.payment_details.exp_month).padStart(2, 0)
    : '';

  const handleShowPopup = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowPopup(!showPopup);
  };

  const handleHidePopup = () => {
    setShowPopup(false);
  };
  const Icon =
    paymentIcons[paymentDetails?.payment_details?.brand?.toLowerCase()];
  const handleSendLink = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      await fetchRequest.post(
        `/payment-methods/${paymentDetails?.id}/send_update_email`,
        {
          shopify_gid: paymentDetails?.processor_payment_method_token,
        },
      );
      noty.success({
        value: 'Link sent. Please check your email',
      });
      setShowPopup(!showPopup);
    } catch {
      noty.error({
        value: 'Something went wrong. Please contact support',
      });
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', handleHidePopup);

    return () => {
      document.body.removeEventListener('click', handleHidePopup);
    };
  });
  return (
    <div className={cn(styles.paymentItem, className)} {...props}>
      <div className={styles.paymentItemTop}>
        {Icon && <Icon />}
        {showUpdate && (
          <>
            <button
              data-cy={`show-payment-popup-${paymentDetails?.payment_details?.last4}`}
              onClick={handleShowPopup}
              className={cn(styles.paymentItemButton, {
                [styles.paymentItemActiveButton]: showPopup,
              })}
            >
              <DotsIcon></DotsIcon>
            </button>
            <button
              onClick={handleSendLink}
              className={cn(styles.paymentItemPopUp, {
                [styles.paymentItemShowPopUp]: showPopup,
              })}
            >
              Send link to update card info
            </button>
          </>
        )}
      </div>
      <div className={styles.paymentItemCardNumber}>
        <span>****</span>
        <span>****</span>
        <span>****</span>
        <span>{paymentDetails?.payment_details?.last4}</span>
      </div>
      <div className={styles.paymentItemExp}>
        <span>Expires</span>
        <span>
          {cardExpMonth}/
          {paymentDetails?.payment_details?.exp_year.toString().slice(2)}
        </span>
      </div>
    </div>
  );
};

export default PaymentItem;
